import { render, staticRenderFns } from "./PageScroller.vue?vue&type=template&id=53b51c87&scoped=true&"
import script from "./PageScroller.vue?vue&type=script&lang=js&"
export * from "./PageScroller.vue?vue&type=script&lang=js&"
import style0 from "./PageScroller.vue?vue&type=style&index=0&id=53b51c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b51c87",
  null
  
)

component.options.__file = "PageScroller.vue"
export default component.exports